import { IButtonStyles, IDetailsListStyles, IIconStyles, IStyle } from '@fluentui/react';
import { FontSizes, IH2OTheme, IInfoStyles, ISearchStyles } from '@h2oai/ui-kit';

export interface IDataTableStyles {
  tableContainer?: IStyle;
  emptyRowContainer?: IStyle;
  emptyRowContentWrapper?: IStyle;
  emptyRowIconWrapper?: IStyle;
  skeletonRow?: IStyle;
}

export const dataTableStylesDefault = (theme: IH2OTheme): Partial<IDataTableStyles> => ({
  tableContainer: {
    backgroundColor: theme.palette?.gray200,
    overflowY: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
    overflowX: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
  },
  emptyRowContainer: {
    display: 'flex',
    backgroundColor: theme.palette?.gray200,
  },
  emptyRowContentWrapper: {
    padding: 16,
    textAlign: 'center',
    width: '100%',
    color: theme.palette?.gray800,
    fontStyle: 'italic',
  },
  emptyRowIconWrapper: {
    marginBottom: '0.25rem',
  },
  skeletonRow: {
    padding: '8px 0',
    width: '100%',
    backgroundColor: theme.palette?.gray200,
  },
});

export const searchStyles = (): Partial<ISearchStyles> => ({
  root: {
    width: '30%',
    margin: '1rem 0',
  },
});

export const iconStyles = (theme: IH2OTheme): Partial<IIconStyles> => ({
  root: {
    fontSize: 24,
    color: theme.palette?.gray800,
  },
});

export const infoStyles: Partial<IInfoStyles> = {
  root: {
    cursor: 'default',
    marginLeft: 4,
  },
};

export const customTableStyles = (
  theme: IH2OTheme,
  contentHeight?: string | number,
  isEmpty?: boolean
): Partial<IDetailsListStyles> => ({
  root: {
    selectors: {
      '.ms-DetailsHeader': {
        padding: '8px 0px',
        paddingRight: 0,
        paddingLeft: 0,
        backgroundColor: theme.palette?.white,
      },
      '.ms-DetailsHeader-cell': {
        borderRight: '1px solid white',
        color: theme.palette?.gray700,
        backgroundColor: theme.palette?.white,
      },
      '.ms-DetailsRow': {
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsRow-cell': {
        display: 'flex',
        alignItems: 'center',
        fontSize: FontSizes.xsmall,
        color: theme.palette?.gray600,
        padding: 8,
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsRow:hover': {
        backgroundColor: theme.palette?.yellow100,
      },
      '.ms-DetailsList-contentWrapper': {
        overflowY: 'auto',
        maxHeight: contentHeight,
        width: !isEmpty ? 'fit-content' : '',
        backgroundColor: theme.palette?.gray200,
      },
    },
  },
});

export const groupIconStyle = (isGrouped: boolean, theme: IH2OTheme): Partial<IButtonStyles> => ({
  root: {
    background: isGrouped ? theme.palette?.gray300 : '',
    color: isGrouped ? theme.palette?.gray500 : theme.palette?.gray700,
  },
  rootHovered: {
    background: isGrouped ? theme.palette?.gray300 : '',
    color: isGrouped ? theme.palette?.gray500 : theme.palette?.gray700,
  },
});

export const tooltipHostStyles = {
  root: {
    display: 'flex',
    marginLeft: '4px',
  },
};
